import React from 'react';
import styled from 'styled-components';
import { keys } from 'lodash';

const AlertsLevelFraudComponent = ({ actionCount, actionList }) => {
  return (
    <StyledDiv>
      {keys(actionCount).map((key) => {
        const actionType = actionList.find(
          ({ displayName }) => displayName?.toLowerCase() === key?.toLowerCase()
        );

        return (
          <div key={key} style={{ color: actionType?.alertLevelColor }}>
            {key}: {actionCount[key]}
          </div>
        );
      })}
    </StyledDiv>
  );
};

const StyledDiv = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 11px;
  font-weight: 500;
  flex-wrap: wrap;
  gap: 12px;
`;

export default AlertsLevelFraudComponent;
